/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { ROLE, useAuth } from '../../../../app/modules/auth'
import { Languages } from './Languages'
import { toAbsoluteUrl } from '../../../helpers'
import { ROLE_NAME } from '../../../../constants'

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-auto'
      style={{ minWidth: '275px' }}
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{currentUser?.uuid}</div>
            <div className='fw-bold text-muted fs-7'>
              {currentUser?.roles.map((role) => {
                return [ROLE.ROLE_EMPLOYEE].includes(role) ? '' : ROLE_NAME[role]
              })}
            </div>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <Languages />

      <div className='menu-item px-5'>
        <Link to='/account' className='menu-link px-5'>
          Учётная запись
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Выход
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
